export default {
	meta: { auth: false },
	children: {
		login: {
			path: "/login",
			meta: { bcText: "Login" },
			component: () => import(
				/* webpackChunkName: "Login" */
				"@/pages/Auth/Login"
			)
		},

		createPassword: {
			path: "/password/create",
			meta: { bcText: "Create Password" },
			component: () => import(
				/* webpackChunkName: "CreatePassword" */
				"@/pages/Auth/CreatePassword"
			)
		},

		forgotPassword: {
			path: "/password/forgot",
			meta: { bcText: "Forgot Password" },
			component: () => import(
				/* webpackChunkName: "ForgotPassword" */
				"@/pages/Auth/ForgotPassword"
			)
		},

		resetPassword: {
			path: "/password/reset",
			meta: { bcText: "Reset Password" },
			component: () => import(
				/* webpackChunkName: "ResetPassword" */
				"@/pages/Auth/ResetPassword"
			)
		},

		register: {
			path: "/register",
			meta: { bcText: "Register" },
			component: () => import(
				/* webpackChunkName: "Register" */
				"@/pages/Auth/Register"
			)
		},

		logout: {
			path: "/logout",
			meta: { auth: true },
			component: () => import(
				/* webpackChunkName: "Logout" */
				"@/pages/Auth/Logout"
			)
		}
	}
};
